<script setup lang="ts">
import AutomarkingInfoButton from "@/modules/calendar/components/AutomarkingInfoButton.vue";

const emit = defineEmits<{
  confirm: [];
  cancel: [];
  "show-info-click": [];
}>();

const onCancel = (): void => {
  emit("cancel");
};

const onConfirm = (): void => {
  emit("confirm");
};

const onShowInfoClick = (): void => {
  emit("show-info-click");
};
</script>

<template>
  <b-modal
    id="automarking-activation-confirm-modal"
    visible
    title-tag="h3"
    ok-variant="secondary"
    no-footer
    size="md"
    @hide="onCancel"
  >
    <template #title>{{ $t("Are you sure you want to enable automatic ordering?") }}</template>

    <p>
      {{
        $t(
          "You are selecting meals that will trigger automatic ordering. Have you read how it works and do you want to activate it?",
        )
      }}
    </p>

    <div class="d-flex flex-wrap gap-2 justify-content-between align-items-center mt-4">
      <AutomarkingInfoButton @click="onShowInfoClick" />

      <div class="d-flex gap-2">
        <button type="button" class="btn btn-outline-secondary" @click="onCancel">
          {{ $t("Cancel") }}
        </button>

        <button type="button" class="btn btn-primary" @click="onConfirm">
          {{ $t("Yes, enable") }}
        </button>
      </div>
    </div>
  </b-modal>
</template>
